export default {"src":"/_next/static/media/GetToWork.004c8bc6.svg","height":80,"width":80,"blurWidth":0,"blurHeight":0};